import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  canActivate(): Observable<boolean> {
    return this.authService.isLoggedIn$.pipe(
      take(1), // Take the latest value and complete
      map(isLoggedIn => {
        if (isLoggedIn) {
          return true; // If logged in, allow access to the route
        } else {
          this.router.navigate(['/interview']);
        }
        {
          // If not logged in, redirect to the login page
          this.router.navigate(['/auth/sign-in']);
          return false; // And block access to the route
        }
      })
    );
  }
}
